import React, { FunctionComponent, ReactNode, MouseEvent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import classnames from 'classnames';

import { SeoLink_linkData } from './__generated__/SeoLink_linkData.graphql';

import styles from './SeoLink.scss';

export const PARTIALLY_LINKABLE_LINK: 'PARTIALLY_LINKABLE_LINK' = 'PARTIALLY_LINKABLE_LINK';
export const ALWAYS_LINKABLE_LINK: 'ALWAYS_LINKABLE_LINK' = 'ALWAYS_LINKABLE_LINK';

type Props = {
    children: ReactNode;
    onClick?: (e: MouseEvent<HTMLElement>) => void;
    linkData: SeoLink_linkData;
    dataTn: string;
    className?: string;
    variant?: typeof PARTIALLY_LINKABLE_LINK | typeof ALWAYS_LINKABLE_LINK;
    style?: React.CSSProperties;
};

const SeoLinkComponent: FunctionComponent<Props> = ({
    children,
    linkData,
    onClick = () => {},
    dataTn,
    className,
    variant = ALWAYS_LINKABLE_LINK,
    style,
}) => {
    const { path, isLinkable } = linkData;

    if (!path) {
        return <>{children}</>;
    }

    if (isLinkable) {
        return (
            <a href={path} onClick={onClick} data-tn={dataTn} className={className} style={style}>
                {children}
            </a>
        );
    }

    return {
        [PARTIALLY_LINKABLE_LINK]: (
            <span onClick={onClick} data-tn={dataTn} className={className} style={style}>
                {children}
            </span>
        ),
        [ALWAYS_LINKABLE_LINK]: (
            <span
                onClick={(e: MouseEvent<HTMLElement>) => {
                    //TODO: shift click
                    onClick(e);
                    window.location.href = path;
                }}
                data-tn={dataTn}
                className={classnames(className, styles.jsLink)}
                style={style}
            >
                {children}
            </span>
        ),
    }[variant];
};

export const SeoLink = createFragmentContainer(SeoLinkComponent, {
    linkData: graphql`
        fragment SeoLink_linkData on LinkData {
            path
            isLinkable
        }
    `,
});
